import { clamp } from '../sim/math.js';
import { secondsToTicks } from './state.js';
export function computeScore(stats, wonMatch, mode, balance, roundTicks) {
    const sc = balance.scoring;
    const accuracy = stats.shotsFired > 0 ? stats.shotsHit / stats.shotsFired : 0;
    const accuracyT = sc.accuracyHigh > sc.accuracyLow
        ? clamp((accuracy - sc.accuracyLow) / (sc.accuracyHigh - sc.accuracyLow), 0, 1)
        : 0;
    const damageDealt = Math.round(stats.damageDealt);
    const roundWins = stats.roundsWon * sc.roundWin;
    const matchWin = wonMatch ? sc.matchWin : 0;
    const accuracyBonus = Math.round(sc.accuracyBonusMax * accuracyT);
    const timeBonus = roundTicks > 0 ? Math.round((stats.timeBonusTicks / roundTicks) * sc.timeBonusPerRound) : 0;
    const firstBlood = stats.firstBlood ? sc.firstBlood : 0;
    const selfDamage = Math.round(stats.selfDamage);
    const total = Math.max(0, damageDealt + roundWins + matchWin + accuracyBonus + timeBonus + firstBlood - selfDamage);
    const credits = Math.round((sc.credits.base +
        sc.credits.perRoundWin * stats.roundsWon +
        (wonMatch ? sc.credits.perMatchWin : 0)) *
        sc.credits.modeScale[mode]);
    return {
        damageDealt,
        roundWins,
        matchWin,
        accuracyBonus,
        timeBonus,
        firstBlood,
        selfDamage,
        total,
        xp: Math.floor(total / sc.xpDivisor),
        credits,
        accuracy,
    };
}
export function computeResult(t) {
    const s = t.s;
    const winner = s.flow.wins[0] >= s.config.roundsToWin ? 0 : s.flow.wins[1] >= s.config.roundsToWin ? 1 : null;
    const roundTicks = secondsToTicks(s.config.roundSeconds);
    return {
        winner,
        reason: 'rounds',
        scores: [
            computeScore(s.stats[0], winner === 0, s.config.mode, t.ctx.balance, roundTicks),
            computeScore(s.stats[1], winner === 1, s.config.mode, t.ctx.balance, roundTicks),
        ],
    };
}
//# sourceMappingURL=scoring.js.map